// strings/emotes.ts (M0-T06, §7.1) — one name per EmoteId
import type { StringBank } from '../schema/strings';

export default {
  wave: 'Wave', laugh: 'Laugh', clap: 'Clap', dance: 'Dance', sit: 'Sit', surprised: 'Surprised', heart: 'Heart', sleepy: 'Sleepy',
} as const satisfies StringBank;
